import { HttpParams } from '@angular/common/http';

// Return the sanitized URL as a string
export function makeUrl(uri: string, params: Record<string, any>) {
  return `${uri}?${new HttpParams({ fromObject: params }).toString()}`;
}
